import GuidedCaptureOptionsStore from '../store/schema/GuidedCaptureOptionsStore';
import { mutator } from 'satcheljs';
import getGuidedCaptureOptions from '../store/store';
import { setAutoCollectionEnabled } from '../actions/guidedCaptureOptionActions';

/**
 * Saves the autoCollectionEnabled option in store
 */
export default mutator(setAutoCollectionEnabled, actionMessage => {
    let optionState: GuidedCaptureOptionsStore = getGuidedCaptureOptions();
    optionState.autoCollectionEnabled = actionMessage.autoCollectionEnabled;
});
